import { EventMeta } from '../../../interfaces/meta.interface';

const update: EventMeta = {
    title: 'Message Updated',
    default: {
        description: 'Message Updated',
        longDescription: 'A message or its properties were changed.',
        severity: 'info',
    },
};

export default update;
